import { getImage } from '@utils/imageHelper';
import {
  EnquiryThankyouSection,
  ThankyouWrapper,
  ImageContainer,
  Confetti,
  PulsatingGreenTick,
  ThankyouHeader,
  ThankyouSubHeader
} from './styles';

const EnquiryThankyou = () => {
  return (
    <EnquiryThankyouSection>
      <ThankyouWrapper>
        <ImageContainer>
          <Confetti
            alt="confetti"
            src={getImage('bundles/offlineConfetti.gif')}
          />
          <PulsatingGreenTick
            size="65px"
            color="var(--color-i-green)"
            viewBox="4 4 16 16"
          />
        </ImageContainer>
        <ThankyouHeader>Thank you</ThankyouHeader>
        <ThankyouSubHeader>
          Your details have been captured Let’s crack it with Unacademy!
        </ThankyouSubHeader>
      </ThankyouWrapper>
    </EnquiryThankyouSection>
  );
};

export default EnquiryThankyou;
